function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnSocialClub = function SvgBtnSocialClub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M25 50h25V25c0 13.807-11.193 25-25 25zM0 25v25h25C11.193 50 0 38.807 0 25zM25 0H0v25C0 11.193 11.193 0 25 0zM25 0c13.807 0 25 11.193 25 25V0H25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M25 0C11.193 0 0 11.193 0 25s11.193 25 25 25 25-11.193 25-25S38.807 0 25 0zm0 37.89s-13.516-9.227-13.516-15.281c0-3.613 2.769-7.995 7.366-7.995 4.601 0 6.149 4.082 6.149 4.082s1.55-4.082 6.149-4.082c4.598 0 7.366 4.383 7.366 7.997C38.516 28.666 25 37.89 25 37.89z"
  }));
};
export default SvgBtnSocialClub;